module.exports = __webpack_public_path__ + "static/media/left-arrow.282e3978.svg";